var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPngPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0, .st1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #003c72;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #007bff;\r\n      }\r\n\r\n      .st1 {\r\n        stroke: #007bff;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    className: "st2",
    d: "M.3,29.4h2.7v-3.5l-3,3.6h0s.1-.1.2-.1h.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    className: "st1",
    d: "M13,1h17.1c1.4,0,2.5,1.1,2.5,2.4v35.4c0,1.3-1.1,2.4-2.5,2.4H5.4c-1.4,0-2.5-1.1-2.5-2.4V10.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    className: "st3",
    d: "M12.9.4v7.8c0,1.4-1.1,2.5-2.6,2.5H2.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    className: "st2",
    d: "M35.8,29.4h-2.8v-3.5l3,3.6h0s0-.1-.2-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    className: "st3",
    d: "M33.2,37.2c0,.2-.3.4-.6.4H3.4c-.2,0-.5-.2-.6-.4L0,29.7C0,29.6,0,29.4.1,29.3h35.6s.3,0,.3.2h0c0,.1-2.8,7.5-2.8,7.5,0,0,0,.2,0,.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_68",
    className: "st2",
    d: "M17.2,10.2c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9-6.9-3.1-6.9-6.9,3.1-6.9,6.9-6.9h0ZM17.2,23c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9-5.9,2.6-5.9,5.9h0c0,3.3,2.6,5.9,5.9,5.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line_48",
    className: "st2",
    d: "M25.5,25.6c-.1,0-.3,0-.4-.1l-3.5-3.5c-.2-.2-.2-.5,0-.7s.5-.2.7,0l3.5,3.5c.2.2.2.5,0,.7,0,0-.2.1-.4.1h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13 19.6 21.4 19.6 18.4 15.4 16.6 18 15.5 16.3 13 19.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 15.9,
    cy: 14,
    r: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1,33.4c-.1.2-.3.4-.6.5-.3.1-.6.2-1,.2h-.9v1.9h-.8v-4.8h1.7c.4,0,.7,0,1,.2.3.1.5.3.6.5s.2.5.2.7,0,.5-.2.7ZM13.2,33.3c.2-.1.2-.3.2-.6,0-.5-.3-.8-.9-.8h-.9v1.6h.9c.3,0,.5,0,.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,36.1h-.8l-2.4-3.6v3.6h-.8v-4.8h.8l2.4,3.6v-3.6h.8v4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,32.7c-.1-.2-.3-.4-.5-.5-.2-.1-.5-.2-.8-.2s-.6,0-.9.2c-.3.1-.5.3-.6.6s-.2.6-.2.9,0,.6.2.9c.1.3.3.5.6.6.3.1.5.2.9.2s.8-.1,1.1-.4c.3-.2.4-.6.5-1h-1.8v-.6h2.7v.6c0,.4-.2.7-.4,1-.2.3-.5.6-.9.7-.4.2-.7.3-1.2.3s-.9-.1-1.3-.3-.7-.5-.9-.9-.3-.8-.3-1.3.1-.9.3-1.3.5-.7.9-.9c.4-.2.8-.3,1.3-.3s1,.1,1.4.4.7.6.9,1.1h-1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngPreview);
export default __webpack_public_path__ + "static/media/PNG Preview.e995ce7c72d1bc32d6381a59a7d98fd2.svg";
export { ForwardRef as ReactComponent };